<app-modal
	*ngIf="vo$ | async ; let vo" class="app-column-model-config-modal">
	<div modal-body class="app-column-model-config-modal__body">
		<dc-alert
			class="info"
			type="info"
			message="info"
			i18n-message="@@subscription.profile.config.modal.description">
		</dc-alert>

		<div class="app-column-model-config-modal__content">
			<app-card-outline>
			<span card-outline-title
						i18n="@@subscription.columnModel.config.metadata">
				column-model-metadata</span>

				<form card-outline-content [formGroup]="columnModelConfigForm.form">
					<mat-form-field [appearance]="Appearance">
						<mat-label
							i18n="@@subscription.columnModel.config.form.label">
							label</mat-label>
						<input
							type="text"
							id="{{ cmpId + '-columnLabel-input' }}"
							matInput
							[formControlName]="ColumnConfigFormControls.Label" />

						<mat-error
							*ngIf="
							columnModelConfigForm.form
							.get(ColumnConfigFormControls.Label)
							?.hasError(ValidationErrorKeys.Maxlength)"
							i18n="@@general.form.errors.maxlength">
							max length
						</mat-error>
						<mat-error
							*ngIf="
								columnModelConfigForm.form
									.get(ColumnConfigFormControls.Label)
									?.hasError(ValidationErrorKeys.Required)"
							i18n="@@general.form.errors.required">
							max length
						</mat-error>
					</mat-form-field>

					<mat-form-field [appearance]="Appearance" >
						<mat-label
							i18n="@@subscription.columnModel.config.form.description">
							description
						</mat-label>
						<textarea
							type="text"
							[rows]="4"
							id="{{ cmpId + '-columnDescription-input' }}"
							matInput
							[formControlName]="ColumnConfigFormControls.Description"></textarea>

						<mat-error
							*ngIf="
							columnModelConfigForm.form
								.get(ColumnConfigFormControls.Description)
								?.hasError(ValidationErrorKeys.Maxlength)"
							i18n="@@general.form.errors.maxlength">
							max length
						</mat-error>
					</mat-form-field>
				</form>
			</app-card-outline>

			<app-panel
				headerHeight="3rem"
				isAlwaysOpen="true"
				hasSearchableGrid="true"
				[itemsCount]="vo.columns.size"
				hasRefresh="true"
				(refresh)="refreshColumnList()"
				(search)="columnsGrid.search($event)">
				<div panel-title class="app-panel__title">
					<mat-icon [svgIcon]="ComponentIcons.Column"></mat-icon>
					<span
						i18n="@@subscription.columnModel.config.columns.list.title">
					columns</span>
				</div>
				<div panel-info class="select-info">
					<ng-container *ngIf="vo.selectedColumnCount" >
						<span>{{ vo.selectedColumnCount }} &#32;</span>
						<span
							i18n="@@subscription.columnModel.config.columns.selectedElements">
						selected-elements</span>
					</ng-container>
				</div>

				<app-columns-config
					#columnsGrid="ColumnsGrid"
					[columns]="vo.columns"
					[isInViewMode]="false"
					[isInModelConfigMode]="true"
					(updatedColumnList)="updateColumnList($event)"></app-columns-config>
			</app-panel>
		</div>
	</div>

	<div modal-footer class="app-column-model-config-modal__footer">
		<div *ngIf="vo.error" class="error-alert error">
			<mat-icon
				[ngClass]="{ 'warning': vo.error.type === 'warning' }"
				color="warn"
				[svgIcon]="vo.error.type === 'critic'? DcIcons.Error: DcIcons.Warning"></mat-icon>
			<span>{{vo.error.message}}</span>
		</div>

		<button
			id="{{ cmpId }}-save-btn"
			[disabled]="vo.error !== undefined"
			[color]="'primary'"
			(click)="vo.action === ColumnModelConfigAction.Create?  createAction() : updateAction()"
			mat-raised-button>
			<span
				*ngIf="vo.action === ColumnModelConfigAction.Create"
				i18n="@@subscription.action.validate">
				validate</span>

			<span
				*ngIf="vo.action === ColumnModelConfigAction.Update"
				i18n="@@general.action.update">
				update</span>
		</button>
	</div>
</app-modal>
